import React, { useMemo, useState, useEffect } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Stack, TextField, Alert
} from "@mui/material";

type SaveArtworkViewDialogProps = {
    open: boolean;
    onClose: () => void;
    onSave: (name: string) => Promise<void>;
    saving?: boolean;
    currentScopeText?: string;
};

const SaveArtworkViewDialog: React.FC<SaveArtworkViewDialogProps> = ({
    open,
    onClose,
    onSave,
    saving = false,
    currentScopeText
}) => {
    const [name, setName] = React.useState("");

    React.useEffect(() => {
        if (open) setName("");
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Save Current View</DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2}>
                    <TextField
                        autoFocus
                        label="View Name"
                        fullWidth
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />

                    {currentScopeText && (
                        <Alert severity="info">
                            {currentScopeText}
                        </Alert>
                    )}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={saving}>Cancel</Button>
                <Button
                    variant="contained"
                    disabled={saving || !name.trim()}
                    onClick={() => onSave(name.trim())}
                >
                    Save View
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SaveArtworkViewDialog;